import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

import { API, ITENSPORPAGINA } from "../../app.config";

@Injectable()
export class GrupoEconomicoService {
    constructor(private http: HttpClient) {}

    buscarPorParametro(param: string, pagina: Number): Observable<any> {
        const headers = new HttpHeaders().set("noloader", "t");

        if (param.length > 0) {
            return this.http.get<any>(
                `${API}/api/grupoeconomico/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`,
                { headers: headers }
            );
        } else {
            return this.http.get<any>(`${API}/api/grupoeconomico?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {
                headers: headers,
            });
        }
    }

    buscarPorId(id: number): Observable<any> {
        return this.http.get<any>(`${API}/api/grupoeconomico/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any> {
        return this.http.delete<any>(`${API}/api/grupoeconomico/${id}`);
    }

    salvar(GrupoEconomico: any): Observable<any> {
        if (GrupoEconomico.Id > 0) {
            return this.http.put<any>(`${API}/api/grupoeconomico/${GrupoEconomico.Id}`, GrupoEconomico);
        } else {
            return this.http.post<any>(`${API}/api/grupoeconomico/`, GrupoEconomico);
        }
    }
}
